module.exports = __webpack_public_path__ + "static/media/categoryDetailPicture.772a5324.png";